import {Injectable} from "@angular/core";
import {CurrencyService} from "../currency/currency.service";
import {I18nServices} from "../i18n/i18n.service";

@Injectable({
  providedIn: 'root'
})
export class StringUtils {

  constructor(protected currencyService: CurrencyService,
              protected i18nService: I18nServices){}

  /*
    Workaround to fix problem in TransferState cache and content which includes '</script>'
   */
  public escapeTransferStateCacheData(data: string): string {
    let returnValue: string = null;
    if(data != null) {
      returnValue = data.replace(/<\/script>/g, 'END_SCRIPT_TAG');
    }
    return returnValue;
  }

  public unescapeTransferStateCacheData(data: string): string {
    let returnValue: string = null;
    if(data != null) {
      returnValue = data.replace(/END_SCRIPT_TAG/g, '</script>');
    }
    return returnValue;
  }

  public nameToId(name) {
    let id = name.toLowerCase().replace(/\s+/g, '-').replace(/[^-a-z0-9]/g, '');
    return id;
  }

  public formatCurrencyWithoutDecimals(value: number, useCompactNotation = false): string {
    return this.formatCurrency(value, false, useCompactNotation);
  }

  public formatCurrency(value: number, showDecimals: boolean = true, useCompactNotation = false): string {
    let selectedCurrency = this.currencyService.getSelectedCurrency();
    //if value is not a number
    if (isNaN(value) || selectedCurrency == null) {
      return "";
    }
    return this.i18nService.formatCurrency(value, selectedCurrency.code, showDecimals, useCompactNotation);

  }

}
